import React from 'react';
import { Box, Grid, Typography, Stack, CardMedia, Button } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import BuildIcon from '@mui/icons-material/Build';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BlockIcon from '@mui/icons-material/Block';
import DescriptionIcon from '@mui/icons-material/Description';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import QrCodeOutlinedIcon from '@mui/icons-material/QrCodeOutlined';
import { useNavigate } from 'react-router-dom';

const InspectionComparisonWeb = () => {
  const navigate = useNavigate();

  const localPoints = [
    {
      text: 'Limited checks, often less than 30 points',
      icon: <SearchIcon sx={{ fontSize: 18, color: '#333333' }} />,
    },
    { text: 'No written report or warranty', icon: <CloseIcon sx={{ fontSize: 18, color: '#333333' }} /> },
    {
      text: 'Skill level varies from mechanic to mechanic',
      icon: <BuildIcon sx={{ fontSize: 18, color: '#333333' }} />,
    },
    { text: 'No accountability after purchase', icon: <HandshakeIcon sx={{ fontSize: 18, color: '#333333' }} /> },
    { text: 'Hidden issues can go unnoticed', icon: <BlockIcon sx={{ fontSize: 18, color: '#333333' }} /> },
    { text: 'Inspection not stored or verifiable', icon: <DescriptionIcon sx={{ fontSize: 18, color: '#333333' }} /> },
  ];

  const focusPoints = [
    { text: '130+ point expert checklist', icon: <SearchOutlinedIcon sx={{ fontSize: 18, color: '#333333' }} /> },
    {
      text: 'Detailed digital inspection report',
      icon: <HeadsetMicOutlinedIcon sx={{ fontSize: 18, color: '#333333' }} />,
    },
    { text: 'Certified and trained technicians', icon: <BuildOutlinedIcon sx={{ fontSize: 18, color: '#333333' }} /> },
    {
      text: 'Warranty assurance on inspected components',
      icon: <SecurityOutlinedIcon sx={{ fontSize: 18, color: '#333333' }} />,
    },
    {
      text: 'Dedicated customer support and post-check help',
      icon: <HeadsetMicOutlinedIcon sx={{ fontSize: 18, color: '#333333' }} />,
    },
    {
      text: 'QR-enabled online reports—easily shareable and verifiable',
      icon: <QrCodeOutlinedIcon sx={{ fontSize: 18, color: '#333333' }} />,
    },
  ];
  return (
    <Stack px="75px" pt={2} pb={11} sx={{ backgroundColor: '#FFFFFF' }}>
      <Typography fontSize={48} fontWeight={700} color="#121212" my={7} textAlign="center">
        What makes us different..
      </Typography>
      <Box sx={{ px: 0 }}>
        <Grid container spacing={12} justifyContent="center" alignItems="stretch">
          {/* Local Mechanic */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                border: ' 1px solid #12121240',
                borderRadius: '24px',
                backgroundColor: '#12121208',
                overflow: 'hidden',
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <CardMedia
                component="img"
                src="assets/images/Inspection/localCarWeb.webp"
                alt="Local Mechanic"
                sx={{ width: '100%', borderTopLeftRadius: '16px', borderTopRightRadius: '12px' }}
              />
              <Stack spacing={2} pt={3}>
                <Typography fontSize="28px" fontWeight={700} color="#333333" lineHeight={1.2} textAlign="center">
                  Normal Checking <br />
                  (by a Local Mechanic)
                </Typography>

                <Stack spacing={1.5}>
                  {localPoints.map((point, i) => (
                    <Box key={i} display="flex" alignItems="center" gap={1.2}>
                      <Box mt={0.5}>{point.icon}</Box>
                      <Typography fontSize="16px" color="#333333">
                        {point.text}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Stack>
            </Box>
          </Grid>

          {/* Certified Inspection */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                border: '1px solid #E95300',
                borderRadius: '24px',
                background:
                  'linear-gradient(191.96deg, rgba(255, 209, 168, 0.15) 0.42%, rgba(179, 109, 63, 0.08) 91.26%)',
                overflow: 'hidden',
                p: 3,
                display: 'flex',
                flexDirection: 'column',

                height: '100%',

                boxShadow: '0px 4px 10px rgba(0,0,0,0.05)',
              }}
            >
              <CardMedia
                component="img"
                src="assets/images/Inspection/focusWeb.webp"
                alt="Certified Inspection"
                sx={{ width: '100%', borderTopLeftRadius: '16px', borderTopRightRadius: '12px' }}
              />
              <Stack spacing={2} pt={3}>
                <Typography fontSize="28px" fontWeight={700} lineHeight={1.2} color="#FF5100" textAlign="center">
                  Certified Inspection <br />
                  by FOCUS
                </Typography>

                <Stack spacing={1.5}>
                  {focusPoints.map((point, i) => (
                    <Box key={i} display="flex" alignItems="flex-start" gap={1.2}>
                      <Box mt={0.5}>{point.icon}</Box>
                      <Typography fontSize="16px" color="#121212">
                        {point.text}
                      </Typography>
                    </Box>
                  ))}
                </Stack>

                <Button
                  onClick={() => navigate('/inspection-booking')}
                  fullWidth
                  sx={{
                    mt: 3,
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: 600,
                    textTransform: 'none',
                    py: 1.2,
                    color: '#fff',
                    background: 'linear-gradient(90deg, #F1761B 0%, #FF5100 100%)',
                    '&:hover': {
                      background: 'linear-gradient(90deg, #e46d19 0%, #e64800 100%)',
                    },
                  }}
                >
                  Book Your Inspection Now
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export default InspectionComparisonWeb;
